import React, {createContext, useReducer} from "react";
import {AssociatePerformanceReducerV2} from "../reducers/AssociatePerformanceReducerV2";

export const AssociatePerformanceContextV2 = createContext()

const AssociatePerformanceContextProvider = (props) => {
    const state = {
        sortPref: {column: "alias", direction: "ascending"},
        associatePerformance: [],
        baseURL: ""
    }
    const [viewModel, dispatch] = useReducer(AssociatePerformanceReducerV2, state);
    return (
        <AssociatePerformanceContextV2.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AssociatePerformanceContextV2.Provider>
    )
}

export default AssociatePerformanceContextProvider


// WEBPACK FOOTER //
// ./src/components/outboundassociate/context/AssociatePerformanceContextV2.js